import { call, put, takeLatest } from 'redux-saga/effects';

import * as url from '../../helpers/url_helper';

// Crypto Redux States
import { salesOrdersTypes } from './actionTypes';
import { getSaleOrdersListSuccess, getSaleOrdersListFail, getMilestoneConfigSOSuccess, getMilestoneConfigSOFail } from './actions';
import { SolarPower } from '@mui/icons-material';
import { getMilestoneConfigOperation } from '../../helpers/GetMilestoneConfigOperation';

let controller = new AbortController();
let signal = controller.signal;

export const cancelFetchSO = () => {
  controller.abort(); 
  controller = new AbortController(); 
  signal = controller.signal;
};

export const fetchSaleOrders = async (data: any) => {
    const { from, to, order, dynamicFilter, dynamicFilterCF } = data.form;
    const { sizePerPage, page } = data.pagination;

    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query {
    GetSalesOrders(SalesOrders: {
      userId: ${user.id || ''},
      initial_date: "${from || ''}",
      final_date: "${to + ' 11:59:00' || ''}",
      order : "${order}",
      ${dynamicFilterCF}
      ${dynamicFilter}
      }, Pagination:{
        sizePage:${sizePerPage},
        actualPage:${page}
      })
      {
        salesOrdersData {
          id
          Number
          CreatedOn
          Status
          ShippingDate
          BuyerName
          SellerName
          PaymentTerms
          ExchangeRate
          CreatorNetworkID
          TotalPieces
          TotalAmountInCurrency
          IsAcceptedBySeller
          IsOnline
          IsCancelled
          CFstatus_gwae
          CFwh_location
          CFbrand
          CFcommodity_type

          ApprovedByName
          Notes
          ReferenceNumber
          AreaPrecision
          DbClassType
          DocumentTemplateName
          IsOnlineTransaction
          IsTrackingEmailSent  
          LastLineID  
          LengthPrecision
          LengthUnit      
          VolumePrecision  
          VolumeUnit 
          VolumeWeightPrecision
          WeightPrecision  
          WeightUnit
          VolumeWeightUnit
          GUID
          customFields {
            name
            value
            internalName
          }
        }
        CountItems
      }
    }`;
    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        signal,
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());
    return response.data.GetSalesOrders;
};


function* fetchSaleOrderSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchSaleOrders, data.payload);
        yield put(getSaleOrdersListSuccess(response));
    } catch (error) {
        yield put(getSaleOrdersListFail(error));
    }
}

function* getMilestoneConfigSO(data: any): any {
  try {
    const response: Promise<any> = yield call(getMilestoneConfigOperation, {
      OperationType: "SO",
      ...data.payload,
    });
    yield put(getMilestoneConfigSOSuccess(response));
  } catch (error) {
    yield put(getMilestoneConfigSOFail(error));
  }
}

function* SalesOrderSaga() {
    yield takeLatest(salesOrdersTypes.GET_ORDERS_DEFINITIONS, fetchSaleOrderSaga);
    yield takeLatest(salesOrdersTypes.GET_MILESTONESCONFIG_SO,getMilestoneConfigSO)
}

export default SalesOrderSaga;
